<div class="container">
  <h1 style="text-align: center;">Benvenuto</h1>

  <h3 style="text-align: center; font-weight: normal;">
    QuoVado riunisce i migliori Travel Designer per realizzare
    itinerari di viaggio su misura per le esigenze dei clienti.
    <br />Diciamo addio al tempo perso e allo stress dell’organizzazione, diamo
    il benvenuto ai viaggi più esclusivi di sempre.
  </h3>
  <h3 style="text-align: center; margin-bottom: 25px;">
    Entra in My QuoVado, l’area riservata a te.
  </h3>
</div>
<div class="container-stretto">
  <p style="text-align: center;">
    <button mat-raised-button color="primary" (click)="signInWithGoogle()" class="social-login-button">
      <img src="/assets/social-login-icons/google.png" class="social-login-icon" />
      Accedi con Google
    </button>
  </p>
  <p style="text-align: center;">
    <button mat-raised-button color="primary" (click)="signInWithFacebook()" class="social-login-button">
      <img src="/assets/social-login-icons/facebook.png" class="social-login-icon" />
      Accedi con Facebook
    </button>
  </p>

  <p style="text-align: center;"><small>oppure</small></p>

  <p style="text-align: center;" *ngIf="!loginFormVisible">
    <button mat-raised-button color="primary" (click)="loginFormVisible = true" class="social-login-button">
      <mat-icon class="social-login-icon" style="color: #333333;">mail</mat-icon>
      Accedi con Email
    </button>
  </p>

  <app-login-form *ngIf="loginFormVisible" (submitted)="signInWithEmailAndPassword($event)"></app-login-form>

  <hr style="margin-top: 30px;" />

  <p style="text-align: center;">
    <small>Se sei già nostro cliente, utilizza lo stesso indirizzo email che hai
      specificato in fase di richiesta itinerario.</small>
  </p>

  <p style="text-align: center;">
    <small>Hai problemi ad accedere? scrivici a
      <a href="mailto:info@quovado.com">info@quovado.com</a></small>
  </p>

  <hr />
</div>

<app-footer-legal></app-footer-legal>